<template>
    <div v-if="dateInfo">
        <v-layout row wrap>
            <v-flex xs4 md4>
              <v-select :items="yearList"
                        item-text="name"
                        item-value="key"
                        v-model="dateInfo.year"
                        :disabled="isDisabled"
                        label="年"
                        outline
                        :background-color="backgroundColor"
                        @change="changeYear"
              ></v-select>
            </v-flex>
            <v-flex xs4 md4>
              <v-select :items="monthList"
                        item-text="name"
                        item-value="key"
                        v-model="dateInfo.month"
                        :disabled="isDisabled"
                        label="月"
                        outline
                        :background-color="backgroundColor"
                        @change="changeMonth"
              ></v-select>
            </v-flex>
            <v-flex xs4 md4 v-if="!dateInfo.onlyMonth">
              <v-select :items="dayList"
                        item-text="name"
                        item-value="key"
                        v-model="dateInfo.day"
                        :disabled="isDisabled"
                        label="日"
                        outline
                        :background-color="backgroundColor"
                        @change="changeDay"
              ></v-select>
            </v-flex>
        </v-layout>
    </div>


</template>

<script>
export default {
  data() {
    return {
    };
  },
  props: ['dateInfo', 'disabled', 'propertyKey', 'backgroundColor'],
  created() {
    // console.log(`dateTool === ${JSON.stringify(this.dateInfo)}`);
    if (this.dateInfo && !this.dateInfo.disabled) {
      this.dateInfo.disabled = false;
    }
  },
  computed: {
    isDisabled() {
      // console.log(`dateTool === ${JSON.stringify(this.dateInfo)} disabled ${this.disabled}`);
      if (this.dateInfo && this.dateInfo.disabled) {
        return this.dateInfo.disabled;
      }
      return !!this.disabled;
    },
    yearList() {
      const startCount = this.dateInfo.startCount === undefined ? 10 : this.dateInfo.startCount ;
      const start = this.dateInfo.onlyOneYear ?
        new Date().getFullYear() + 3 : new Date().getFullYear() + startCount;
      const end = this.dateInfo.onlyOneYear ?
        new Date().getFullYear() - 3 : 1911;

      const list = [];
      for (let i = start; i >= end; i -= 1) {
        if (this.dateInfo.isRepublic) {
          list.push({ key: `${i - 1911}`, name: `${i - 1911}` });
        } else {
          list.push({ key: `${i}`, name: `${i}` });
        }
      }
      return list;
    },
    monthList() {
      // if(this.dateInfo.onlyOneYear){
      //
      //     let month = new Date().getMonth();
      //     let lastMonth = new Date().getMonth()+1;
      //     let monthKey =  month < 10 ? '0'+month : month;
      //     let lastMonthKey =  lastMonth < 10 ? '0'+lastMonth : lastMonth;
      //     return [
      //         {name: monthKey, key: monthKey},
      //         {name: lastMonthKey, key: lastMonthKey},
      //     ]
      // }
      return [
        { name: '01', key: '01' },
        { name: '02', key: '02' },
        { name: '03', key: '03' },
        { name: '04', key: '04' },
        { name: '05', key: '05' },
        { name: '06', key: '06' },
        { name: '07', key: '07' },
        { name: '08', key: '08' },
        { name: '09', key: '09' },
        { name: '10', key: '10' },
        { name: '11', key: '11' },
        { name: '12', key: '12' },
      ];
    },
    dayList() {
      // 取今天
      // let now = new Date();
      // 取當月最後一天
      // let endDate = new Date();
      // endDate.setMonth(endDate.getMonth()+1);
      // endDate.setDate(1);
      // endDate.setDate(endDate.getDate()-1);

      const startIndex = 1;

      const list = [];
      for (let i = startIndex; i <= 31; i += 1) {
        if (i < 10) {
          list.push({ key: `0${i}`, name: `0${i}` });
        } else {
          list.push({ key: `${i}`, name: `${i}` });
        }
      }
      // for(let i= endDate.getDate() ; i >= now.getDate() ; i--){
      //     list.push({key:`${i}` , name:`${i}`});
      // }
      return list;
    },
  },
  methods: {
    changeYear() {
      if (this.dateInfo.year !== '' && this.dateInfo.month !== '' && this.dateInfo.day !== '') {
        if (!this.dateInfo.isRepublic) {
          if (parseInt(this.dateInfo.year, 10) < 1911) {
            this.dateInfo.year = parseInt(this.dateInfo.year, 10) + 1911;
          }
        }
        const date = `${this.dateInfo.year}-${this.dateInfo.month}-${this.dateInfo.day}`;
        this.$emit('handleDateChange', date);
      }
    },
    changeMonth() {
      if (this.dateInfo.year !== '' && this.dateInfo.month !== '' && this.dateInfo.day !== '') {
        if (!this.dateInfo.isRepublic) {
          if (parseInt(this.dateInfo.year, 10) < 1911) {
            this.dateInfo.year = parseInt(this.dateInfo.year, 10) + 1911;
          }
        }
        const date = `${this.dateInfo.year}-${this.dateInfo.month}-${this.dateInfo.day}`;
        this.$emit('handleDateChange', date);
      }
    },
    changeDay() {
      if (this.dateInfo.year !== '' && this.dateInfo.month !== '' && this.dateInfo.day !== '') {
        if (!this.dateInfo.isRepublic) {
          if (parseInt(this.dateInfo.year, 10) < 1911) {
            this.dateInfo.year = parseInt(this.dateInfo.year, 10) + 1911;
          }
        }
        const date = `${this.dateInfo.year}-${this.dateInfo.month}-${this.dateInfo.day}`;
        this.$emit('handleDateChange', date);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dateTimeTool.vue